import { Form } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { SwitchableInput } from 'app/components/commons/SwitchableInput/SwitchableInput';
import { CustomInput } from 'app/components/fields/Input';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { parseInputNumber } from 'app/utils/typing';

type MaxAddonQuantityProps = {
  label?: string;
  suffix?: string;
};

export const MaxAddonQuantity = ({
  label = 'Max. Add-on quantity',
  suffix = 'maximum per booking.',
}: MaxAddonQuantityProps) => {
  const { isViewMode, isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const maxAddonQuantityEnabled = Form.useWatch('maxAddonQuantity', form);
  const maxQuantityValue = Form.useWatch('maxQuantity', form);

  return (
    <FormLineLayout label={label} labelOnTop>
      <Form.Item name="maxAddonQuantity">
        <SwitchableInput
          value={!!maxAddonQuantityEnabled}
          noBackground
          noBorder
          disabled={isViewMode}
          childNode={
            maxAddonQuantityEnabled && (
              <div className="max-quantity-rule">
                <Form.Item
                  name="maxQuantity"
                  rules={[{ required: true, message: 'Required' }]}
                  noStyle
                >
                  {isEditMode ? (
                    <CustomInput
                      onWheel={(e) => e.currentTarget.blur()}
                      min={0}
                      parser={parseInputNumber}
                      disabled={!maxAddonQuantityEnabled}
                    />
                  ) : (
                    <Form.Item name="maxQuantity" noStyle>
                      <span>{maxQuantityValue}</span>
                    </Form.Item>
                  )}
                </Form.Item>
                <span>{suffix}</span>
              </div>
            )
          }
        />
      </Form.Item>
    </FormLineLayout>
  );
};
